<div class="run-grid">
  <div class="card pad">
    <div class="run-head">
      <div class="pulse" [class.done]="!df.running">
        <df-icon [name]="df.running ? 'spark' : 'check'" [size]="18"></df-icon>
      </div>
      <div>
        <div class="q-echo">{{ df.query }}</div>
        <div class="hint run-status">
          {{ df.running ? 'Searching… this can take up to a few minutes.'
             : df.searchError ? 'Search failed: ' + df.searchError
             : 'Search complete. ' + foundCount + ' documents found and grouped by type.' }}
        </div>
      </div>
    </div>

    <p *ngIf="df.searchWarning" class="hint" role="status">{{ df.searchWarning }}</p>

    <div class="counters">
      <div class="ctr"><b class="c-scan">{{ counters.scan | number }}</b><span>files scanned</span></div>
      <div class="ctr"><b class="c-cand">{{ counters.cand | number }}</b><span>candidates</span></div>
      <div class="ctr"><b class="c-rel">{{ counters.rel | number }}</b><span>relevant documents</span></div>
      <div class="ctr"><b class="c-flag">{{ counters.flag | number }}</b><span>need your call</span></div>
    </div>

    <ol class="trace">
      <li *ngFor="let t of trace; let i = index" [ngClass]="stateOf(i)">
        <span class="dot">
          <span style="color:#fff;display:inline-flex"><df-icon name="check" [size]="14"></df-icon></span>
        </span>
        <div class="trace-content" (click)="toggleTrace(i)">
          <h4>{{ t.title }}</h4>
          <p>{{ t.detail }}</p>
          <div class="log" *ngIf="expanded.has(i) && t.log.length"><span *ngFor="let l of t.log">{{ l }}</span></div>
        </div>
        <span class="tm">{{ timeOf(i) }}</span>
        <button type="button" class="expand-btn" (click)="toggleTrace(i)">
          <df-icon [name]="expanded.has(i) ? 'chevronUp' : 'chevronDown'" [size]="16"></df-icon>
        </button>
      </li>
    </ol>

    <div class="row-actions">
      <button type="button" class="btn back-btn" (click)="back()">Change question</button>
      <button type="button" class="btn pri review-btn" [disabled]="df.running" (click)="review()">
        {{ df.running ? 'Searching…' : 'Review ' + foundCount + ' documents' }}
      </button>
    </div>
  </div>

  <div class="card stream">
    <div class="stream-h"><b>Found so far</b><span class="hint s-count">{{ stream.length }} documents</span></div>
    <div>
      <div class="s-item" *ngFor="let d of stream">
        <df-file-badge [ext]="d.ext"></df-file-badge>
        <div style="min-width:0">
          <div class="nm">{{ d.name }}</div>
          <div class="sub">
            <span [style.color]="docTypes[d.t].color" style="font-weight:700">{{ docTypes[d.t].short }}</span>
            · {{ landscapeLabel(d.land) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
